import { render, staticRenderFns } from "./ReceivePayment.vue?vue&type=template&id=6eb79560&"
import script from "./ReceivePayment.vue?vue&type=script&lang=js&"
export * from "./ReceivePayment.vue?vue&type=script&lang=js&"
import style0 from "./ReceivePayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports